import React, { useState } from 'react';

import { copyDocumentHtmlToClipboard } from '../validators/asesValidator';

const AmawebValidator = ({ pathname }) => {
  const [amawebWizardStarted, setAmawebWizardStarted] = useState(false);

  const handleAmawebStart = () => {
    copyDocumentHtmlToClipboard();
    setAmawebWizardStarted(true);
  };

  return (
    <section
      className="a11y-panel a11y-panel--info"
      aria-labelledby="amaweb-panel-title"
    >
      <div className="a11y-panel__icon" aria-hidden="true">
        <span className="fa-solid fa-circle-info" />
      </div>
      <div className="a11y-panel__content a11y-panel__content--horizontal">
        <div className="a11y-panel__text">
          <div className="a11y-panel__title" id="amaweb-panel-title">
            {amawebWizardStarted
              ? 'Agora valide seu código na ferramenta Amaweb'
              : 'Valide a acessibilidade do seu conteúdo'}
          </div>
          <div className="a11y-panel__body">
            {amawebWizardStarted ? (
              <ol>
                <li>
                  Clique em <strong>Acessar ferramenta AMAWeb</strong> para
                  abrir o site.
                </li>
                <li>
                  No site AMAWeb, acesse a aba <strong>Inserir HTML.</strong>
                </li>
                <li>Cole o código copiado no formulário da ferramenta.</li>
                <li>
                  Avalie os resultados e consulte os erros de acessibilidade
                  identificados.
                </li>
              </ol>
            ) : (
              <p className="m-0 amaweb-note">
                O código da página será copiado para a sua área de
                transferência.
              </p>
            )}
          </div>
        </div>
        <div className="a11y-panel__actions">
          {amawebWizardStarted ? (
            <a
              href="https://amaweb.unifesp.br/avaliador"
              target="_blank"
              rel="noopener noreferrer"
              className="br-button primary small"
            >
              Acessar ferramenta AMAWeb
            </a>
          ) : (
            <button
              className="br-button primary small"
              onClick={handleAmawebStart}
            >
              Iniciar
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default AmawebValidator;
